import { useFormikSubmit } from "@certn/api";
import {
  ButtonGroup,
  Grid,
  GridItem,
  PhoneNumberInputField,
  PrimaryButton,
} from "@certn/cascadia-react";
import { phoneNumberSchema } from "@certn/cascadia-react/components/inputs/phone-number/schema";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { SettingsEditItem } from "../../../components/settings-edit/SettingsEditItem";
import { useUser } from "../../../hooks/api/useUser";

export function PhoneSettings() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);
  const { details: userDetails, refresh } = useUser();

  const phoneNumber = userDetails?.phone_number;

  const { submit } = useFormikSubmit(
    "/api/internal/applicant/me/personal-info/phone/update/",
    {
      onSuccess: () => {
        toggle();
        refresh();
      },
      showToastOnError: true,
    }
  );

  return (
    <SettingsEditItem
      setting={t("Phone number")}
      value={phoneNumber || "-"}
      description={t("To receive help logging in and for notifications.")}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "phone-number-cancel-link" : "phone-number-edit-link"}
    >
      <Formik
        initialValues={{
          phone_number: phoneNumber || "",
        }}
        onSubmit={submit}
        validationSchema={phoneNumberSchema}
      >
        <Form>
          <Grid width="416px" form>
            <GridItem>
              <PhoneNumberInputField
                name="phone_number"
                label={t("Phone number")}
                type="string"
                isRequired
              />
            </GridItem>
            <GridItem>
              <ButtonGroup>
                <PrimaryButton
                  type="submit"
                  size="medium"
                  testID="phone-number-save-button"
                >
                  {t("Save")}
                </PrimaryButton>
              </ButtonGroup>
            </GridItem>
          </Grid>
        </Form>
      </Formik>
    </SettingsEditItem>
  );
}
